import React from 'react'
import { Controller, useFieldArray, useFormContext } from 'react-hook-form'
import { Checkbox, Form, Grid, Input } from 'semantic-ui-react'
import { CO2El } from '../../../style'
import { FormFields } from '~/components/FormFields'
import { useTranslation } from 'react-i18next'
import InfoPopup from '~/components/InfoPopup'

interface Props {
  options: any[]
}

const EnergyFields: React.FC<Props> = ({ options }) => {
  const { t } = useTranslation()
  const { control, getValues } = useFormContext()

  const { fields, append, remove } = useFieldArray({
    control,
    name: 'energyConsumptions',
    keyName: 'key'
  })

  function handleChecked(field, checked) {
    if (checked) {
      append({
        ...field,
        percent: ''
      })
      return
    }
    const index = fields.findIndex(fieldEnergie => fieldEnergie['id'] === field.id)
    if (index >= 0) {
      remove(index)
    }
  }

  function checkPercentage() {
    const energyTypes = getValues('energyConsumptions')
    return energyTypes.reduce((previousValue, currentValue) => {
      return previousValue + parseFloat(currentValue.percent.replace(',', '.'))
    }, 0) !== 100
  }

  return <Form.Field>
    <label style={{ fontSize: '15px' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
        <div>{t('Energy use (electricity)')}</div>
        <InfoPopup
          content={t('Please select all the types from which you receive your electricity. Then distribute the percentage share among the selected options. In total these must add up to 100%.')}
          styleIcon={{ fontSize: '1.2em' }}
          position={'top center'}
        />
      </div>
    </label>
    <CO2El.StyledDivider />
    <Grid columns={2} style={{ marginTop: '1em' }}>
      <Controller
        name={'energyConsumptions'}
        control={control}
        rules={{
          validate: () => !checkPercentage()
        }}
        render={({ fieldState }) => {
          const error = fieldState.error ? checkPercentage() : false
          return <>
            {options.map((option) => {
              const fieldIndex = fields.findIndex(field => field['id'] === option.id)
              return <Grid.Row style={{ alignItems: 'center', padding: '0.6rem 0rem' }} key={option.id}>
                <Grid.Column width={5}>
                  <Checkbox
                    label={option.label}
                    checked={Boolean(fields.find(energyField => energyField['id'] === option.id))}
                    onChange={(e, data) => handleChecked(option, data.checked)}
                  />
                </Grid.Column>
                <Grid.Column>
                  {fieldIndex >= 0 ? <FormFields.Input
                    control={control}
                    allowDecimals
                    decimalScale={2}
                    style={{ width: 200 }}
                    error={error}
                    typeInput={'controled'}
                    suffix={' %'}
                    noErrorMessage
                    withoutAsterisk
                    rules={{
                      required: true
                    }}
                    name={`energyConsumptions[${fieldIndex}].percent`}
                    placeholder={t('in %')}
                  /> : <Input
                    style={{ width: 200 }}
                    disabled
                    placeholder={t('in %')}
                  />
                  }
                </Grid.Column>
              </Grid.Row>
            })}
          </>
        }}
      />
    </Grid>
  </Form.Field>
}
export default EnergyFields